export default __webpack_public_path__ + "static/media/send-poll.284040e7.svg";